import { MutationTree } from 'vuex';
import { IState } from './type';

const mutations: MutationTree<IState> = {
  setIsReadonly(state, isReadonly) {
    state.isReadonly = isReadonly;
  },
  setInfo(state, info) {
    state.info = info;
  },
  setResource(state, resource) {
    state.resource = resource;
  }
};

export default mutations;
